<template>
  <div class="imgUpload" v-loading="loading">
    <el-alert
      v-if="!readonly"
      size="mini"
      type="primary"
      :closable="false"
      ><!-- 图片支持{{ (accept === "image/*" && "任意") || accept }}格式，最大体积{{
        size
      }}MB，图片可通过
      <a style="color: #f00" href="https://tinify.cn/" target="_blank"
        >https://tinify.cn/</a
      >
      在不失真情况下将体积压缩到更小哦！ -->
      <!-- Picture support{{ (accept === "image/*" && "any") || accept }}format，maximum{{
        size
      }}MB，pictures can be
      <a style="color: #f00" href="https://tinify.cn/" target="_blank"
        >https://tinify.cn/</a
      > 
      Compress to smaller size!-->
      The picture size is no more than {{ size }}MB, and supports {{ (accept === "image/*" && "any") || accept }} formats.
      <el-button
        size="mini"
        type="primary"
        v-if="batchRemovable && images.length > 1"
        @click="clear"
        >批量删除</el-button
      >
    </el-alert>
    <vuedraggable
      class="vue-draggable"
      v-model="images"
      tag="ul"
      draggable=".draggable-item"
      @start="onDragStart"
      @end="onDragEnd"
      :class="{ maxHidden: isMaxHidden }"
    >
      <!-- 拖拽元素 -->
      <li
        v-for="(item, index) in imgList"
        :key="index"
        :class="readonly ? 'elImage_show' : 'draggable-item'"
        :style="{ width: width + 'px', height: height + 'px' }"
      >
        <el-image-custom
          :src="imgList"
          :width="width"
          :height="height + 'px'"
          :index="index"
          :border="false"
          preview
          fit="contain"
        />
        <div
          class="delImgIcon"
          v-if="!readonly"
          @click="onRemoveHandler(index, item)"
        >
          <i class="icon-lajitong iconfont"></i>
        </div>
      </li>

      <!-- 上传按钮 -->
      <el-upload
        slot="footer"
        ref="uploadRef"
        class="uploadBox"
        list-type="picture"
        :style="{ width: width + 'px', height: height + 'px' }"
        :multiple="multiple"
        :limit="limit"
        :accept="accept"
        :auto-upload="true"
        :show-file-list="false"
        :headers="headers"
        :action="(!oss && action) || undefined"
        :http-request="(oss && upload2oss) || undefined"
        :before-upload="beforeUpload"
        :on-exceed="onExceed"
        :on-success="onSuccess"
        :name="name"
        v-if="!readonly"
      >
        <i class="uploadIcon">
          <icon class="el-icon-camera-solid"></icon>
          <span class="limitTxt">Select image</span>
        </i>
      </el-upload>
    </vuedraggable>
    <el-descriptions
      :column="1"
      size="small"
      v-if="remoteSupported && !readonly"
    >
      <el-descriptions-item label="链接上传图片">
        <el-input
          class="link-input"
          type="text"
          label="链接上传图片"
          placeholder="请输入图片链接"
          v-model="imgLink"
          maxlength="200"
          size="small"
          @input="checkCanUploadLink"
          clearable
        />
        <el-button
          type="primary"
          :disabled="!canUploadLink"
          size="small"
          @click="uploadLink"
          >+ 上传图片</el-button
        >
        <el-alert
          v-if="canUploadLink && uploadLinkError !== ''"
          class="upload-link-error"
          type="warning"
          show-icon
        >
          {{ uploadLinkError }}
          <a :href="imgLink" target="_blank">打开链接</a>
        </el-alert>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import vuedraggable from "vuedraggable";
import * as publicApi from "@/http/publicApi.js";
import { cmofferApi } from "@/http/cmofferApi.js";
import axios from "axios";
import ElImageCustom from "./elImageCustom.vue";
export default {
  props: {
    // 是否为 oss
    oss: {
      type: Boolean,
      default: true,
    },
    // 图片数据
    images: {
      type: Array,
      default: [],
    },
    // 限制上传的图片数量
    limit: {
      type: Number,
      default: 100,
    },
    // 限制上传图片的文件大小(MB)
    size: {
      type: Number,
      default: 3,
    },
    // 是否使用图片压缩
    useCompress: {
      type: Boolean,
      default: true,
    },
    // 图片显示的宽度(px)
    width: {
      type: Number,
      default: 100,
    },
    // 图片显示的高度(px)
    height: {
      type: Number,
      default: 100,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    // 显示条件
    show: {
      type: Boolean,
      default: false,
    },
    // 图片格式
    accept: {
      type: String,
      default: "image/*",
    },
    action: {
      type: String,
      default: cmofferApi.uploadToSite_url,
    },
    name: {
      type: String,
      default: "img",
    },
    // 引用图片上传的组件的类型
    type: String,
    batchRemovable: {
      type: Boolean,
      default: false,
    },
    // 远程图片上传
    remoteSupported: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    onlyOne: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      headers: {
        token: localStorage.getItem("token"),
      },
      imgList: [],
      accessid: "",
      accesskey: "",
      host: "",
      policyBase64: "",
      signature: "",
      callbackbody: "",
      filename: "",
      key: "",
      expire: 0,
      g_object_name: "",
      g_object_name_type: "",
      suffix: "",
      res_file_name: "",
      upFile: "",
      loading: false,
      imgLink: "",
      canUploadLink: false,
      uploadLinkError: "",
    };
  },

  computed: {
    // 控制达到最大限制时隐藏上传按钮
    isMaxHidden() {
      return this.imgList.length >= this.limit;
    },
  },
  watch: {
    images: {
      handler(newVal) {
        this.imgList = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    clear() {
      this.$refs.uploadRef && this.$refs.uploadRef.clearFiles();
      this.imgList = [];
      this.$emit("imagesChange", []);
    },
    // 移除单张图片
    onRemoveHandler(index, item) {
      this.$confirm("确定删除该图片?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除不调用接口,直接把图片路径移除
          this.imgList.splice(index, 1);
          this.$emit("imagesChange", this.imgList);
          return
          publicApi
            .delFile(
              {
                image_url: item,
              },
              "post"
            )
            .then((res) => {
              if (res) {
                this.imgList.splice(index, 1);
                this.$emit("imagesChange", this.imgList);
              }
            });
        })
        .catch(() => {});
    },
    onDragStart(e) {
      e.target.classList.add("hideShadow");
      this.$emit("imagesChange", this.imgList);
    },
    onDragEnd(e) {
      e.target.classList.remove("hideShadow");
      this.$emit("imagesChange", this.imgList);
    },
    onExceed() {
      this.$message.error(`文件不能超过${this.limit} 张`);
    },
    onSuccess(res) {
      this.loading = false;
      if (this.imgList.length >= this.limit) {
        this.$message.error(`文件不能超过${this.limit} 张`);
      } else {
        if ((res.errcode || res.code) === 200) {
          this.imgList.push(res.data.url);
          this.$emit("imagesChange", this.imgList);
        } else {
          this.$message.error(res.msg || res.errmsg);
        }
      }
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < this.size; //这里做文件大小限制

      if (!isLt2M) {
        this.$message.warning(`上传文件大小不能超过 ${this.size} MB!`);
        return false;
      }

      return true;
    },
    /**
     *  token
     */
    async getOssToken() {
      return axios
        .get(`${cmofferApi.ossToken_url}?t=${new Date().getTime()}`)
        .then((res) => res.data);
    },
    /**
     * 获取拓展名
     */
    get_suffix(filename) {
      return filename.substring(filename.lastIndexOf("."));
    },
    // 上传 oss
    async upload2oss(fileObj) {
      const { file } = fileObj;
      this.loading = true;
      return this.getOssToken().then((tokenData) => {
        const { host, policy, accessid, signature, callback } = tokenData;
        const key =
          tokenData.filename + this.get_suffix(file.name).toLowerCase();
        const photo = file; // 获取图片对象

        let param = new FormData();
        param.append("name", key);
        param.append("key", key);
        param.append("policy", policy);
        param.append("OSSAccessKeyId", accessid);
        param.append("success_action_status", 200); // 不要问为什么，照做
        param.append("callback", callback);
        param.append("signature", signature);
        param.append("file", photo, key); // 这个**切记**一定要放到最后去 append ，不然阿里云会一直报 key 的错误

        return axios
          .post(host, param)
          .then((res) => {
            return res.data;
          })
          .catch(() => {
            this.$message.error("上传文件失败");
          });
      });
    },
    checkCanUploadLink(value) {
      this.canUploadLink =
        /^https?:\/\/[a-z0-9\-]+\.[a-z0-9\-]+[\.a-z0-9]*\/[\?\.\w\-\:\+\/,&=%\u4e00-\u9fa5]+$/i.test(
          value
        );
      this.uploadLinkError = "";
    },
    uploadLink() {
      this.uploadLinkError = "";
      this.loading = true;
      axios({
        method: "post",
        url: cmofferApi.proxyImg_url,
        data: {
          link: this.imgLink,
          accept: this.accept,
          size: this.size * 1024 * 1024,
        },
        responseType: "json",
        headers: {
          token: localStorage.getItem("token"),
        },
        timeout: 20000,
      })
        .then((res) => {
          this.onSuccess(res.data);
          // clear
          this.imgLink = "";
          this.uploadLinkError = "";
          this.loading = false;
        })
        .catch(() => {
          this.uploadLinkError =
            "从链接地址获取图片失败，请先另存到本地电脑后再点击上方按钮上传";
          this.loading = false;
        });
    },
  },
  components: { vuedraggable, ElImageCustom },
};
</script>

<style lang="scss">
.imgUpload {
  .elImage_show {
    margin: 10px 10px 0 0;
    text-align: center;
    .el-image {
      width: 100%;
      height: 100%;
    }
  }
  .words {
    color: red;
    font-size: 8px;
  }
  .text {
    font-size: 12px;
    color: #f56c6c;
    text-align: left;
    width: 100%;
  }
  // 上传按钮
  .uploadIcon {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid $border-color-base;
    background-color: #fbfdff;
    border-radius: 0;
    icon {
      color: $color-text-placeholder;
      font-size: 60px;
      margin-bottom: 24px;
    }
    .limitTxt {
      position: absolute;
      bottom: 24px;
      left: 0;
      margin: 0 10px;
      width: calc(100% - 20px);
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      color: $color-primary;
    }
  }

  // 拖拽
  .vue-draggable {
    display: flex;
    flex-wrap: wrap;
    .draggable-item {
      margin: 10px 10px 0 0;
      border: 1px solid #ddd;
      border-radius: 0;
      position: relative;
      overflow: hidden;
      text-align: center;
      .el-image {
        width: 100%;
        height: 100%;
      }
      .delImgIcon {
        position: absolute;
        bottom: 0;
        left: 0;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        opacity: 0;
        transition: opacity 0.3s;
        cursor: pointer;
        font-size: 12px;
        line-height: 16px;
        padding: 2px;
      }
      &:hover {
        .delImgIcon {
          opacity: 1;
        }
      }
    }
    &.hideShadow {
      .delImgIcon {
        display: none;
      }
    }
    &.single {
      overflow: hidden;
      position: relative;

      .draggable-item {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
      }
    }
    &.maxHidden {
      .uploadBox {
        display: none;
      }
    }
  }
  // el-image
  .el-image-viewer__wrapper {
    .el-image-viewer__mask {
      opacity: 0.8;
    }
    .el-icon-circle-close {
      color: #fff;
    }
  }
  .uploadBox {
    margin-top: 10px;
    .el-upload {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .el-descriptions {
    margin-top: 30px;
    .el-descriptions-item__label.has-colon {
      line-height: 32px;
      display: inline-block;
      width: 80px;
    }
    .el-descriptions-item__container {
      display: block;
      .link-input {
        width: 75%;
        margin-right: 10px;
        top: 1px;
      }

      .upload-link-error {
        margin-left: 105px;
        margin-left: 90px;
        width: 728px;
        margin-top: 10px;
        .el-alert__icon.el-icon-warning.is-big {
          font-size: 16px;
          width: 16px;
        }

        a {
          color: #f00;
          margin-left: 10px;
        }

        .el-alert__closebtn {
          top: 14px;
        }
      }
    }
  }
}
</style>
